// deps
import React, { memo } from "react";

// constants
import { TEXTS } from "@payment-ui/constants/index";

import styles from "../PayLater.v4.scss";

interface TnCProps {
    tncUrl?: string;
    dataTestId?: string;
}

export const TnC = memo(function PayLaterTnC(props: TnCProps): React.ReactElement | null {
    const { tncUrl } = props;
    if (tncUrl == null) {
        return null;
    }

    return (
        <div className={styles.dialogContentTnc}>
            <a
                href={tncUrl}
                rel="noopener noreferrer"
                className={styles.dialogContentTncLink}
                data-testid={props.dataTestId}
            >
                {TEXTS.TERMS_AND_CONDITIONS}
            </a>
            <span>{TEXTS.APPLY}</span>
        </div>
    );
});
